import { render } from "./NewsCards.vue?vue&type=template&id=6623c0d0&scoped=true"
import script from "./NewsCards.vue?vue&type=script&lang=js"
export * from "./NewsCards.vue?vue&type=script&lang=js"

import "./NewsCards.vue?vue&type=style&index=0&id=6623c0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6623c0d0"]])

export default __exports__